var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "subtasks" },
    [
      _vm._l(_vm.taskStreamList, function (taskStream) {
        return _c(
          "div",
          {
            key: taskStream.id,
            class: {
              "stream-name": true,
              "stream-name_active": _vm.selectedStream.id === taskStream.id,
            },
            on: {
              click: function ($event) {
                return _vm.selectStream(taskStream.id)
              },
            },
          },
          [
            _c("span", [_vm._v(_vm._s(taskStream.name))]),
            _vm._v(" "),
            _vm.taskStreamList.length > 1 && _vm.isAccessAllow
              ? _c("Icon", {
                  attrs: { id: "delete" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      _vm.deleteConfirm = taskStream
                    },
                  },
                })
              : _vm._e(),
          ],
          1
        )
      }),
      _vm._v(" "),
      _vm.isAccessAllow
        ? _c("SubtasksNew", { attrs: { urlTaskId: _vm.urlTaskId } })
        : _vm._e(),
      _vm._v(" "),
      _vm.deleteConfirm
        ? _c("ReactiveConfirm", {
            attrs: {
              confirmText: "Удалить",
              title: `Удалить подзадачу <br>"${_vm.deleteConfirm.name}?"`,
            },
            on: {
              close: function ($event) {
                _vm.deleteConfirm = null
              },
              confirm: _vm.deleteStream,
            },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }